import React, { Suspense, useMemo, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Collapse, Select, Skeleton, Typography } from 'antd';
import dayjs from 'dayjs';

import { MONTHS_INDEX } from '../../constant/constant';
import { generateYears } from '../../ReusableFn/reusableFn';
import { RxCaretDown } from 'react-icons/rx';
import { styled } from '@mui/material';
import SelfReviewMonthForm from './SelfReviewMonthForm';
import { useAuth } from '../../Context/AuthContext';

const { Title } = Typography;

const ContainerSelfReview = styled('div')({
  '& .ant-collapse': {
    background: 'transparent',
  },

  '& .ant-collapse-item': {
    marginBottom: 12,
    border: 'none',
  },
  '& .ant-collapse > .ant-collapse-item > .ant-collapse-header': {
    backgroundColor: 'white',
    borderRadius: 4,
  },
  '& .ant-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box':
    {
      padding: 0,
    },
});

const SelfReviewComp = () => {
  const { authState } = useAuth();
  const userId = authState?.id;
  const userRoleId = authState?.userRoleID;
  const [selectedYear, setSelectedYear] = useState(() => dayjs().year());

  const yearOptions = useMemo(() => generateYears() || [], []);

  const collapseItems = useMemo(() => {
    const now = dayjs();

    return MONTHS_INDEX.map(({ label: monthName, value: monthIndex }) => {
      const monthLabel = dayjs()
        .year(selectedYear)
        .month(monthIndex)
        .startOf('month')
        .format('MMM YYYY');

      let isFuture = false;
      if (selectedYear > now.year()) {
        isFuture = true;
      } else if (selectedYear < now.year()) {
        isFuture = false;
      } else {
        isFuture = monthIndex > now.month();
      }

      return {
        key: `${selectedYear}-${monthIndex}`,
        label: (
          <Title
            className={`${isFuture ? 'text-muted opacity-50' : 'fw-semibold text-dark'} `}
            level={4}
          >
            {monthLabel}
          </Title>
        ),
        collapsible: isFuture ? 'disabled' : 'header',
        className: 'mb-2 border-bottom-0',
        children: (
          <Suspense fallback={<Skeleton active />}>
            <SelfReviewMonthForm
              monthLabel={monthLabel}
              readOnly={isFuture}
              month={monthName}
              year={selectedYear}
              userId={userId}
              userRoleId={userRoleId}
            />
          </Suspense>
        ),
      };
    });
  }, [selectedYear, userId, userRoleId]);

  return (
    <div className="container-fluid px-2 px-md-3">
      <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
        <h5 className="mb-0 primaryColor">Staff Review</h5>
        <Select
          size="middle"
          style={{ minWidth: 110 }}
          value={selectedYear}
          options={yearOptions}
          onChange={setSelectedYear}
          aria-label="Year"
        />
      </div>
      <ContainerSelfReview>
        <Row className="justify-content-start">
          <Col>
            <Collapse
              size="large"
              accordion
              expandIcon={({ isActive }) => (
                <RxCaretDown
                  size={28}
                  style={{
                    transition: 'rotate 0.2s ease-in-out',
                    rotate: isActive ? '180deg' : '0deg',
                  }}
                />
              )}
              bordered={false}
              expandIconPosition="end"
              items={collapseItems}
              className="employee-self-review-collapse"
            />
          </Col>
        </Row>
      </ContainerSelfReview>
    </div>
  );
};

export default SelfReviewComp;
